import CourseEntityCard from 'bundles/unified-seo-content-common/components/entity-cards/CourseEntityCard';
import DegreeEntityCard from 'bundles/unified-seo-content-common/components/entity-cards/DegreeEntityCard';
import MasterTrackEntityCard from 'bundles/unified-seo-content-common/components/entity-cards/MasterTrackEntityCard';
import SpecializationEntityCard from 'bundles/unified-seo-content-common/components/entity-cards/SpecializationEntityCard';

export const ENTITY_TYPE_TO_ENTITY_CARDS_MAPPING = {
  course: CourseEntityCard,
  s12n: SpecializationEntityCard,
  profS12n: SpecializationEntityCard,
  project: CourseEntityCard,
  degree: DegreeEntityCard,
  mastertrack: MasterTrackEntityCard,
} as const;
